import { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "./Layout";

const TermsWeb = ({ embedded = false }) => {
  const Container = embedded ? Fragment : Layout;
  const navigate = useNavigate();

  return (
    <Container>
      {" "}
      <div className="br_promotion_main br_main">
        <div className="main-title">
          <div className="game-page-title">
            <div className="game-type-title">
              <span>Terms</span>
            </div>
          </div>
        </div>{" "}
        <div className="content">
          <div className="help-container">
            <div id="this_home_bg" className="common" />
            <div className="help-content">
              <div className="help-list">
                <div className="help-detail-content on">
                  <div className="wysiwyg">
                    <p style={{ "margin-bottom": "0.22rem" }}>
                      <span style={{ "font-size": "11pt" }}>
                        <span style={{ "line-height": "107%" }}>
                          <span style={{ "font-family": "Calibri" }}>
                            <span style={{ "font-size": "11.0000pt" }}>
                              <span style={{}}>
                                <span style={{ color: "#ffffff" }}>
                                  আপনার জন্য সাধারণ নিয়মাবলী (General Rules For
                                  You)
                                </span>
                              </span>
                            </span>
                            <br />
                            <span style={{ "font-size": "11.0000pt" }}>
                              <span style={{}}>
                                <span style={{ color: "#ffffff" }}>
                                  ৭.১ ব্যবহারকারীরা একই মার্কেটে ব্যাক (Back)
                                  এবং লে (Lay) বেট ধরতে পারবেন, যদি সেই বেটগুলো
                                  ন্যায্যভাবে এবং সিস্টেমের কোনো অপব্যবহার না
                                  করে করা হয়।
                                </span>
                              </span>
                            </span>{" "}
                            <br />
                            <span style={{ "font-size": "11.0000pt" }}>
                              <span style={{}}>
                                <span style={{ color: "#ffffff" }}>
                                  ৭.২ অল্প সময়ের ব্যবধানে একই সিলেকশনে বারবার
                                  ব্যাক (Back) এবং লে (Lay) বেট ধরা অনুমোদিত নয়।
                                </span>
                              </span>
                            </span>{" "}
                            <br />
                            <span style={{ "font-size": "11.0000pt" }}>
                              <span style={{}}>
                                <span style={{ color: "#ffffff" }}>
                                  ৭.৩ ঝুঁকিহীন বা ন্যূনতম ঝুঁকিতে বারবার একই বা
                                  প্রায় কাছাকাছি অডসে (Odds) ব্যাক এবং লে বেট
                                  ধরাকে সন্দেহজনক কার্যকলাপ হিসেবে গণ্য করা হবে।
                                </span>
                              </span>
                            </span>{" "}
                            <br />
                            <span style={{ "font-size": "11.0000pt" }}>
                              <span style={{}}>
                                <span style={{ color: "#ffffff" }}>
                                  ৭.৪ মার্কেটের বিলম্ব (Market delay), প্রাইস
                                  ল্যাটেন্সি বা কারিগরি ত্রুটির সুযোগ নেওয়ার
                                  যেকোনো ধরনের প্যাটার্ন কঠোরভাবে নিষিদ্ধ।
                                </span>
                              </span>
                            </span>{" "}
                            <br />
                            <span style={{ "font-size": "11.0000pt" }}>
                              <span style={{}}>
                                <span style={{ color: "#ffffff" }}>
                                  ৭.৫ যদি কোনো ব্যবহারকারী অসৎ উদ্দেশ্যে ক্রমাগত
                                  ব্যাক এবং লে বেট ধরেন, তবে প্ল্যাটফর্ম সেই
                                  ব্যবহারকারীকে 'প্রতারক' (Cheater) হিসেবে
                                  চিহ্নিত করার অধিকার রাখে।
                                </span>
                              </span>
                            </span>{" "}
                            <br />
                            <span style={{ "font-size": "11.0000pt" }}>
                              <span style={{}}>
                                <span style={{ color: "#ffffff" }}>
                                  ৭.৬ সন্দেহজনক বা অন্যায্য বেটিং আচরণের
                                  ক্ষেত্রে, প্ল্যাটফর্ম যেকোনো বেট বাতিল করতে
                                  পারে, ব্যবহারকারীর অ্যাকাউন্ট স্থগিত বা
                                  স্থায়ীভাবে ব্লক করতে পারে এবং সংশ্লিষ্ট জয়ী
                                  অর্থ (Winnings) আটকে রাখতে পারে।
                                </span>
                              </span>
                            </span>{" "}
                            <br />
                            <span style={{ "font-size": "11.0000pt" }}>
                              <span style={{}}>
                                <span style={{ color: "#ffffff" }}>
                                  ৭.৭ সন্দেহজনক কার্যকলাপ এবং অ্যাকাউন্ট
                                  সংক্রান্ত বিষয়ে প্ল্যাটফর্মের সিদ্ধান্তই
                                  চূড়ান্ত এবং বাধ্যতামূলক বলে গণ্য হবে।
                                </span>
                              </span>
                            </span>{" "}
                            <br />
                            <span style={{ "font-size": "11.0000pt" }}>
                              <span style={{}}>
                                <span style={{ color: "#ffffff" }}>
                                  ৭.৮ আপনাকে অবশ্যই নিজের নামে নিবন্ধন করতে হবে
                                  এবং নিজের পক্ষেই খেলতে হবে, অন্য কারো পক্ষে
                                  নয়।
                                </span>
                              </span>
                            </span>{" "}
                            <br />
                            <span style={{ "font-size": "11.0000pt" }}>
                              <span style={{}}>
                                <span style={{ color: "#ffffff" }}>
                                  ৭.৯ আপনার লগইন তথ্য নিরাপদ রাখতে হবে এবং কারো
                                  সাথে শেয়ার করা যাবে না। আপনি যদি
                                  অনিচ্ছাকৃতভাবেও এটি শেয়ার করেন, তবে আপনার
                                  অ্যাকাউন্টের যেকোনো অপব্যবহারের জন্য আপনি
                                  নিজেই দায়ী থাকবেন।
                                </span>
                              </span>
                            </span>{" "}
                            <br />
                            <span style={{ "font-size": "11.0000pt" }}>
                              <span style={{}}>
                                <span style={{ color: "#ffffff" }}>
                                  ৭.১০ আপনার নিবন্ধনের তথ্য সবসময় হালনাগাদ
                                  (Update) রাখতে হবে।
                                </span>
                              </span>
                            </span>{" "}
                            <br />
                            <span style={{ "font-size": "11.0000pt" }}>
                              <span style={{}}>
                                <span style={{ color: "#ffffff" }}>
                                  ৭.১১ যদি বুঝতে পারেন যে নিবন্ধনের সময় ভুল তথ্য
                                  দেওয়া হয়েছে, তবে আপনাকে অবিলম্বে আমাদের জানাতে
                                  হবে অথবা তথ্য সংশোধন করতে হবে।
                                </span>
                              </span>
                            </span>{" "}
                            <br />
                            <span style={{ "font-size": "11.0000pt" }}>
                              <span style={{}}>
                                <span style={{ color: "#ffffff" }}>
                                  ৭.১২ আপনি যে দেশ থেকে খেলছেন, সেখানে সাইটটির
                                  কার্যক্রম বৈধ কিনা তা জানার দায়িত্ব আপনার।
                                </span>
                              </span>
                            </span>{" "}
                            <br />
                            <span style={{ "font-size": "11.0000pt" }}>
                              <span style={{}}>
                                <span style={{ color: "#ffffff" }}>
                                  ৭.৬ (পুনরাবৃত্তি) এই সাইটে আপনার কেবল একটি
                                  অ্যাকাউন্ট রাখার অনুমতি আছে। যদি আপনার একাধিক
                                  অ্যাকাউন্ট থাকে, তবে তা অবিলম্বে আমাদের জানাতে
                                  হবে।
                                </span>
                              </span>
                            </span>{" "}
                            <br />
                            <span style={{ "font-size": "11.0000pt" }}>
                              <span style={{}}>
                                <span style={{ color: "#ffffff" }}>
                                  ৭.১৩ প্রতি পরিবারের জন্য মাত্র একটি
                                  অ্যাকাউন্টের অনুমতি আছে। আপনার পরিবারে একাধিক
                                  অ্যাকাউন্ট আছে বুঝতে পারলে তা অবিলম্বে আমাদের
                                  জানাতে হবে।
                                </span>
                              </span>
                            </span>{" "}
                            <br />
                            <span style={{ "font-size": "11.0000pt" }}>
                              <span style={{}}>
                                <span style={{ color: "#ffffff" }}>
                                  ৭.১৪ আপনার অ্যাকাউন্টে পর্যাপ্ত অর্থ থাকা
                                  সাপেক্ষে আপনি সাইটের যেকোনো গেম খেলতে পারেন।
                                </span>
                              </span>
                            </span>{" "}
                            <br />
                            <span style={{ "font-size": "11.0000pt" }}>
                              <span style={{}}>
                                <span style={{ color: "#ffffff" }}>
                                  ৭.১৫ আপনি এক অ্যাকাউন্ট থেকে অন্য অ্যাকাউন্টে
                                  তহবিল স্থানান্তর করতে পারবেন না এবং অ্যাকাউন্ট
                                  কেনা-বেচা বা হস্তান্তর করা নিষিদ্ধ।
                                </span>
                              </span>
                            </span>{" "}
                            <br />
                            <span style={{ "font-size": "11.0000pt" }}>
                              <span style={{}}>
                                <span style={{ color: "#ffffff" }}>
                                  ৭.১৬ আপনি কে, তা যাচাই করার অধিকার আমাদের আছে।
                                  আপনার নিবন্ধনের তথ্য এবং পেমেন্টের বিবরণ
                                  প্রমাণ করার জন্য আমরা যেসব নথিপত্র (যেমন:
                                  পাসপোর্ট কপি, ইউটিলিটি বিল বা ব্যাংক
                                  স্টেটমেন্ট) চাইব, তা দিতে আপনি সম্মত।
                                </span>
                              </span>
                            </span>{" "}
                            <br />
                            <span style={{ "font-size": "11.0000pt" }}>
                              <span style={{}}>
                                <span style={{ color: "#ffffff" }}>
                                  ৭.১৭ আপনি কোনো কারিগরি ত্রুটি বা দুর্বলতাকে
                                  আপনার সুবিধার্থে ব্যবহার করতে পারবেন না। এভাবে
                                  অর্জিত যেকোনো জয়ী অর্থ বাতিল বা ফেরত নেওয়ার
                                  অধিকার আমাদের থাকবে।
                                </span>
                              </span>
                            </span>{" "}
                            <br />
                            <span style={{ "font-size": "11.0000pt" }}>
                              <span style={{}}>
                                <span style={{ color: "#ffffff" }}>
                                  ৭.১৮ আপনি সাইট ব্যবহারের ক্ষেত্রে কোনো
                                  জালিয়াতি, যোগসাজশ, ফিক্সিং বা অন্য কোনো অবৈধ
                                  কর্মকাণ্ডে লিপ্ত হবেন না। সাইটের গেমে
                                  অংশগ্রহণের জন্য আপনি কোনো সফটওয়্যার বা
                                  হার্ডওয়্যার ডিভাইস ব্যবহার করতে পারবেন না।
                                </span>
                              </span>
                            </span>{" "}
                            <br />
                            <span style={{ "font-size": "11.0000pt" }}>
                              <span style={{}}>
                                <span style={{ color: "#ffffff" }}>
                                  ৭.১৯ ব্যবসা পরিচালনা এবং সাইটটি আপনার কাছে
                                  পৌঁছে দেওয়ার জন্য আমরা আপনার তথ্য অন্য ব্যক্তি
                                  বা প্রতিষ্ঠানের সাথে শেয়ার করতে পারি, সেটিতে
                                  আপনি সম্মত।
                                </span>
                              </span>
                            </span>{" "}
                            <br />
                            <span style={{ "font-size": "11.0000pt" }}>
                              <span style={{}}>
                                <span style={{ color: "#ffffff" }}>
                                  ৭.২০ আপনি একমত যে আপনার প্লেয়ার অ্যাকাউন্টে
                                  সমস্ত জমা/উত্তোলন আপনার নিজের নামের ব্যাংক
                                  অ্যাকাউন্ট, ডেবিট/ক্রেডিট কার্ড বা অন্য
                                  পেমেন্ট মেথডের মাধ্যমে হতে হবে।
                                </span>
                              </span>
                            </span>{" "}
                            <br />
                            <span style={{ "font-size": "11.0000pt" }}>
                              <span style={{}}>
                                <span style={{ color: "#ffffff" }}>
                                  ৭.২১ এভিয়েটর এবং এভোলুশনের কোনো গেমে টার্ণওভার
                                  পূরণ হবে না। টার্ণওভার পূরন করতে হলে অবশ্যই
                                  অন্য গেম খেলতে হবে।
                                </span>
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default TermsWeb;
